import { HIDDEN_SUBJECT } from "Constants/campaign/emailSubjectDisplayTypes";

const mod = {
  namespaced: true,
  state: {
    // be kind and alphabetize 
    advocateGoalCounts: {},
    campaignDesignColors: {},
    contentIntroduction: null,
    contentStakeholderSearchPrompt1: null,
    contentStakeholderSearchPrompt2: null,
    contentStakeholderSearchPrompt3: null,
    contentWillingToCall: null,
    emailSubjectLineDisplayType: HIDDEN_SUBJECT,
    formFields: [],
    invalidFormFieldsErrorMessage: null,
    pageBackground: null,
    relationshipRatings: [],
    relationshipTags: [],
    splitAdvocateNames: false,
    stakeholderDefaultPhotoUrl: null,
    subscribeEmail: true,
    subscribeEmailLabel: "",
    subscribeSms: true,
    subscribeSmsLabel: "",
    subTitle: null,
    thankYouImage: null,
    thankYouMessage: null,
    unknownErrorMessage: null
  },
  mutations: {
    advocateGoalCounts: (state, stats) => {
      state.advocateGoalCounts = stats;
    },
    settings: (state, settings) => {
      Object.keys(settings).forEach((setting) => {
        if (typeof(state[setting]) !== 'undefined') {
          state[setting] = settings[setting];
        }
      })
    }
  },
  actions: {
    advocateGoalCounts({ commit }, stats = {}) {
      commit('advocateGoalCounts', stats);
    },
    fromSettings({ commit }, settings = {}) {
      commit('settings', settings);
    }
  },
  getters: {
    advocateGoalCounts(state) {
      return state.advocateGoalCounts;
    }
  },
};

export default mod;
